import { useRef, useState } from "react"

export class DeviceBoxManagement {


    updateSsMode(targetMode) {
        if (!this._isDeviceAvailable) {
            return
        }
        const promise = this._onStateChange(this._deviceName, 'SET_MODE', targetMode)
        promise.then(() => {
            this._setMode(targetMode)
        }).catch()
    }

    isActive() {
        if (!this._isDeviceAvailable) {
            return false
        }
        return this._mode !== 'frostprotection' && this._mode !== 'off'
    }

    generateSelectOptions() {
        return Object.keys(this._availableModes).map((key) => {
            return <option value={key} key={key}>{this._availableModes[key]}</option>
        })
    }

    switchState() {
        if (!this._isDeviceAvailable) {
            return
        }
        let offState = 'frostprotection'
        if(this._availableModes.hasOwnProperty('off')) {
            offState = 'off'
        }
        if (this.isActive()) {
            this.updateSsMode(offState)
        } else {
            this.updateSsMode('comfort')
        }
    }
}

export default function HousePilotDeviceBoxSS({ deviceName, deviceLabel, mode, availableModes, onStateChange, fullSize = false, isDeviceAvailable = true }) {

    const [smode, setMode] = useState(mode)

    const manager = new DeviceBoxManagement()
    manager._onStateChange = onStateChange
    manager._deviceName = deviceName
    manager._mode = smode
    manager._setMode = setMode
    manager._availableModes = availableModes
    manager._isDeviceAvailable = isDeviceAvailable

    let boxClassSize = fullSize ? 'col-10' : 'col-6 col-md-6 col-lg-3'
    const classActive = manager.isActive() ? ' active' : ''
    const classUnavailable = isDeviceAvailable ? '' : ' unavailable'


    return (
        <>
            <div className={"m-1 " + boxClassSize + " deviceBox " + classActive + classUnavailable}>
                <h6>{deviceLabel}
                    <i className="fa fa-power-off btn-power-switch float-center" onClick={() => { manager.switchState() }}></i></h6>

                {isDeviceAvailable && (
                    <>
                        <i className="fa fa-temperature-1"></i> <select className="d-inline-block w-90 form-control mt-2" value={manager._mode} onChange={(e) => { manager.updateSsMode(e.target.value) }}>
                            {manager.generateSelectOptions()}
                        </select><br />
                    </>
                )}

                {!isDeviceAvailable && (
                    <div className="deviceBox-overlay"><span className="deviceBox-overlay-label">Hors ligne</span></div>
                )}

            </div>


        </>
    )
}
